import { render, staticRenderFns } from "./SalesStatusByPart.vue?vue&type=template&id=34b61d40&scoped=true&"
import script from "./SalesStatusByPart.vue?vue&type=script&lang=js&"
export * from "./SalesStatusByPart.vue?vue&type=script&lang=js&"
import style0 from "./SalesStatusByPart.vue?vue&type=style&index=0&id=34b61d40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b61d40",
  null
  
)

export default component.exports